import React from 'react';
import { useSelector } from 'react-redux';
import { CobuStack, CobuText, CobuImage } from '@cobu/ui';
import type { RootState } from '../../store';

interface ProfileIconProps {
  isActive?: boolean;
  color?: string;
}

export function ProfileIcon({ isActive = false, color }: ProfileIconProps) {
  const user = useSelector((state: RootState) => state.auth.user);
  
  if (!user) {
    return null;
  }

  const activeColor = color || "#14BBD1";
  const inactiveColor = "#B0B0B0";
  const profileImage = user.profileImage || user.avatarUrl;
  const initials = `${user.firstName?.[0] || ''}${user.lastName?.[0] || ''}`.trim() || 'Me';

  return (
    <CobuStack pos="relative" width={24} height={24}>
      {/* SVG Border/Outline */}
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ position: 'absolute', top: 0, left: 0 }}>
        <circle
          cx="12"
          cy="12"
          r="11"
          fill={isActive ? activeColor : 'transparent'}
          stroke={isActive ? 'transparent' : inactiveColor}
          strokeWidth="1.5"
        />
      </svg>
      
      {/* Profile Image/Initials */}
      <CobuStack
        pos="absolute"
        top={2}
        left={2}
        width={20}
        height={20}
        br="$full"
        ai="center"
        jc="center"
        bg="#F4F3F9"
        style={{ overflow: 'hidden' }}
      >
        {profileImage ? (
          <CobuImage
            src={profileImage}
            width={20}
            height={20}
            borderRadius={10}
          />
        ) : (
          <CobuText
            variant="caption"
            color="#272163"
            fontSize={9 as any}
            fontWeight="bold"
          >
            {initials}
          </CobuText>
        )}
      </CobuStack>
    </CobuStack>
  );
}
